import StaffPage from "@/pages/StaffPage";

const OUVREUSES_COLUMNS = [
  { key: "profession", label: "Métier", cls: "hidden md:table-cell" },
  { key: "ville", label: "Ville", cls: "hidden lg:table-cell" },
  { key: "telephone", label: "Téléphone", cls: "hidden lg:table-cell", mono: true },
  { key: "email", label: "Mail", cls: "hidden xl:table-cell" },
];

export default function OuvreusesPage() {
  return (
    <StaffPage
      apiBase="/ouvreuses"
      title="Ouvreuses"
      addLabel="Ouvreur/se"
      showRegistration={true}
      regPath="/inscription-ouvreuse"
      exportName="Sal-BBC-export.txt"
      columns={OUVREUSES_COLUMNS}
      extraSections={[]}
    />
  );
}
